import { subDays, addDays } from "date-fns";

const CRMBirthdayLevelConfigs = {
  master: {
    title: "CRM Birthday Level",
    apiName: "crm/crmbirthdaylevel",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: {
      // add_params
    },
  },
  dialog: {
    title: "CRM Birthday Level",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Level",
      field: "level",
      table: true,
      // filter: true,
      editor: true,
      type: "number_plain",
      align: "right",
    },
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
    },
    {
      name: "Threshold",
      field: "threshold",
      type: "number_plain",
      editor: true,
      align: "right",
      table: true,
    },
    {
      name: "Next Threshold",
      field: "next_threshold",
      type: "number_plain",
      editor: true,
      align: "right",
      table: true,
    },
    {
      name: "Expired Days",
      field: "expired_days",
      type: "number_plain",
      editor: true,
      align: "right",
      table: true,
    },
    {
      name: "Is Max",
      field: "is_max",
      align: "center",
      table: true,
      editor: true,
      type: "boolean_plain",
      filter: true,
    },
  ],
};

export default CRMBirthdayLevelConfigs;
